module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('message-system', {
    attrs: {
      "size": "small"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-vertical is-8"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child"
  }, [_c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Mis Cursos")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('grid-courses', {
    attrs: {
      "go": true,
      "external": true
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child"
  }, [_c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Todos los cursos")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('grid-courses', {
    attrs: {
      "url": "courses/",
      "price": true,
      "teachers": true
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content"
  }, [(!_vm.news) ? _c('p', {
    staticClass: "has-text-centered"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Cargando...\n              ")]) : _vm._e(), _vm._v(" "), (_vm.news && _vm.news.length == 0) ? _c('p', [_vm._v("\n                No hay noticias\n              ")]) : _c('p'), _vm._l((_vm.news), function(item) {
    return _c('div', {
      staticClass: "is-clearfix"
    }, [_vm._v("\n                  " + _vm._s(item.title)), _c('br'), _vm._v(" "), _c('a', {
      staticClass: "is-pulled-right",
      attrs: {
        "href": item.link
      }
    }, [_vm._v("Leer articulo")])])
  }), _vm._v(" "), _c('p')], 2)]), _vm._v(" "), (_vm.blog) ? _c('footer', {
    staticClass: "card-footer"
  }, [_c('p', {
    staticClass: "card-footer-item"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.blog,
      "target": "_blank"
    }
  }, [_vm._v("Ir al blog")])])])]) : _vm._e()])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('span', {
    staticClass: "card-header-title"
  }, [_vm._v("\n              Últimas Noticias\n            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-90f2a656","hasScoped":false}!./src/pages/dashboard/template.html
// module id = 420
// module chunks = 1